<template>
  <div class="header-bar">
    <Row>
      <sider-trigger
        :collapsed="collapsed"
        icon="md-menu"
        @on-change="handleCollpasedChange"
      ></sider-trigger>
      <Col span="6">
      <breadcrumb :currentPath="levelList"></breadcrumb>
      </Col>
      <!--      <Col push="1" span="2">-->
      <!--        <Button icon="md-desktop" type="primary" @click="handleLargeScreenDisplay">大屏展示</Button>-->
      <!--        &lt;!&ndash;<Icon type="md-desktop" />&ndash;&gt;-->
      <!--        &lt;!&ndash;大屏展示&ndash;&gt;-->
      <!--      </Col>-->
      <Col>
      <div class="custom-content-con">
        <slot>
        </slot>
      </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import siderTrigger from './sider-trigger';
import breadcrumb from '@/components/breadcrumb';
import './header-bar.less';
import _ from 'lodash';
export default {
  name: 'HeaderBar',
  components: {
    siderTrigger,
    breadcrumb
  },
  props: {
    collapsed: Boolean
  },
  created() {
    this.getBreadcrumb();
  },
  data() {
    return {
      levelList: []
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  methods: {
    /**
     * 获取当前路径（面包屑）
     */
    getBreadcrumb() {
      console.log('-----------getBreadCrumb---');
      let matched = this.$route.matched.filter(item => item.name);
      const first = matched[0];
      if (first && first.meta.nameEn !== 'Home') { // 除了首页外，其他页面携带首页
        matched = [{
          path: '/home/index',
          meta: {name: '首页', icon: 'ios-home'}
        }].concat(matched);
      }
      // console.log(matched)
      this.levelList = matched;
    },
    handleCollpasedChange(state) {
      this.$emit('on-coll-change', state);
    },
    handleLargeScreenDisplay() {
      let {name, params, query} = {};
      name = 'datav';
      // this.$router.push({
      //   name: name,
      //   query: query,
      //   params: params
      // })
      let routeData = this.$router.resolve({
        name: name,
        query: query,
        params: params
      });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>
